module.exports = __webpack_public_path__ + "static/663925408-square.4e1e8490.jpg";